import qs from 'qs';

export const handleSearchQuery = ({ title, location, workSchedule }) =>
  qs.stringify({
    _where: [
      { location_contains: location },
      {
        _or: [{ titleTR_contains: title }, { titleEN_contains: title }]
      },
      { workSchedules: workSchedule }
    ]
  });

export const handleJobDetailQuery = (slug) => qs.stringify({ slug });
